import Favourite from './Favourite';

export default Favourite;
